import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
const OwlSlider = () => {
  const [owlData, setOwlData] = useState([]);
  const [loading_home, setLoading_home] = useState(true);
  const options = {
    loop: true,
    nav: false,
    dots: true,
    items: 1,
    autoplay: true,
  };

  const fetchOwlData = async () => {
    setLoading_home(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/banner-sliders`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      setOwlData(data.responseObject);
      setLoading_home(false);
    } catch (error) {
      // console.log("error fetch owl data", error);
    }
  };

  useEffect(() => {
    fetchOwlData();
  }, []);

  if (loading_home) {
    return (
      <section className="hero-sec" >
        <div className="container-fluid">
          <div className="hero-sec-innr">
            <div
              className="skeleton-loader"
              style={{
                width: "100vw",
                height: "400px",
                backgroundColor: "#e0e0e0",
                animation: "pulse 1.5s infinite ease-in-out",
                borderRadius: "0px",
                "@media (max-width: 768px)": {
                  height: "100px",
                },
              }}
            />
          </div>
        </div>
      </section>
    );
  }
  return (
    <>
      <section className="hero-sec">
        <div className="container-fluid">
          <div className="hero-sec-innr">
            <OwlCarousel
              className="banner-slide owl-carousel owl-theme "
              {...options}
            >
              {owlData.map(
                (owl, index) =>
                  owl.status === "active" && (
                    <Link
                      key={index}
                      onClick={() =>
                        window.open(`${owl?.redirectUrl}`, "_blank")
                      }
                      to="#"
                    >
                      <div
                        className="item banner-main-img"
                        style={{ borderRadius: 0, width: "100vw" }}
                      >
                        <img
                          src={owl?.imageUrl}
                          className=""
                          alt="banner"
                          style={{
                            width: "100vw",
                            height: "auto",
                            borderRadius: 0,
                            display: "block",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    </Link>
                  )
              )}
            </OwlCarousel>
          </div>
        </div>
      </section>
    </>
  );
};

export default OwlSlider;
